import { REWARD_CURRENCIES } from "@/src/constants/rewardly-currencies";

const RATES_ENDPOINT = "https://open.er-api.com/v6/latest/USD";

export type RewardRates = Record<string, number>;


export const fetchRewardCurrencyRates = async (): Promise<RewardRates> => {
  const res = await fetch(RATES_ENDPOINT);
  if (!res.ok) throw new Error(`FX rates request failed: ${res.status}`);

  const json = await res.json();
  const rates: Record<string, unknown> = json?.rates ?? {};

  return REWARD_CURRENCIES.reduce<RewardRates>((acc, c) => {
    const live = rates[c.code];
    acc[c.code] =
      typeof live === "number" && live > 0 ? live : c.starValue;
    return acc;
  }, {});
};
